<app-site-header />
<section class="content-area-layout1">
    <section class="content-area-layout2">
        <h3>Registered Drones</h3>
        <p>Optional Search Criteria:</p>
        <form [formGroup]="viewDronesForm">
            <div class="field-container">
                <mat-form-field>
                    <mat-label>Serial Number</mat-label>
                    <input matInput #input maxlength="100" formControlName="serialNumber"/>
                </mat-form-field>
                <app-drone-models-component/>
                <mat-form-field>
                    <mat-label>Remote ID</mat-label>
                    <input matInput #input maxlength="255" formControlName="remoteId"/>
                </mat-form-field>
                @if (userTypeEquals("employee")) {
                <app-dealer-names-component (messageEvent)="receiveMessage($event)"/>
                }
                <app-customer-names-component (messageEvent)="receiveMessage($event)"/>
            </div>
        </form>
        <section style="padding-top: 1vw; padding-bottom: 1vw;">
            <button style="margin-right: 1vw;" mat-flat-button (click)="listDrones()">Search</button>
            <button style="margin-right: 1vw;" mat-flat-button (click)="resetSearch()">Reset Search</button>
            @if (userHasRole("drone-editor")) {
            <button mat-flat-button (click)="addDrone()">Add Drone</button>
            }
        </section>

        <p class="text-aerostar-orange">{{message}}</p>

        @if (droneCount > 0) {
        <p>Click on row to expand for additional information.</p>
        <div>
            <mat-accordion>
                <section class="mat-elevation-z2 mat-header-row">
                    <span class="mat-header-cell">Model</span>
                    <span class="mat-header-cell">Serial Number</span>
                    <span class="mat-header-cell">Remote ID</span>
                    <span class="mat-header-cell">Manufacture Date</span>
                    <span class="mat-header-cell">Transferred To</span>
                    @if (userHasRole("drone-editor") || userHasRole("drone-transfer")) {
                    <span class="mat-header-cell">Actions</span>
                    }
                </section>
                <mat-expansion-panel hideToggle *ngFor="let drone of drones">
                    <mat-expansion-panel-header class="mat-row">
                        <span class="mat-cell">{{drone.model}}</span>
                        <span class="mat-cell">{{drone.serial_number}}</span>
                        <span class="mat-cell">{{drone.remote_id}}</span>
                        <span class="mat-cell">{{drone.manufacture_date | date:'mediumDate' : 'Local'}}</span>
                        <span class="mat-cell">{{getTransferNotation(drone)}}</span>
                        @if (userHasRole("drone-editor") || userHasRole("drone-transfer")) {
                        <span class="mat-cell">
                            <ng-container matColumnDef="more-vert">
                                <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="View and Update Actions"
                                    (click)=$event.stopPropagation()>
                                    @if ((userHasRole("drone-transfer") && isTransferable(drone))
                                    ||   (userHasRole("drone-editor") && isNonProd)) {
                                    <mat-icon>more_vert</mat-icon>
                                    } @else {
                                    <mat-icon>block</mat-icon>
                                    }
                                </button>
                                <mat-menu #menu="matMenu">
                                    @if (userHasRole("drone-transfer") && isTransferable(drone)) {
                                    <button mat-menu-item (click)="transferDrone(drone.id)">
                                        <span>Transfer Drone</span>
                                    </button>
                                    }
                                    @if (userHasRole("drone-editor") && isNonProd) {
                                    <button mat-menu-item>
                                        <span (click)="deleteDrone(drone.id, drone.serial_number)">Delete
                                            Drone<br><sup>(Limited to Non-Prod Env)</sup></span>
                                    </button>
                                    }
                                </mat-menu>
                            </ng-container>
                        </span>
                        }
                    </mat-expansion-panel-header>
                    <div>
                        <hr>
                        @for (drone_transfer of drone.drone_transfers; track drone_transfer.id) {
                        <br>
                        <div>
                            <b>Transferred to</b> {{getTransferredToName(drone_transfer)}},
                            {{drone_transfer.transferred_date | date:'mediumDate' : 'Local'}}
                        </div>
                        }
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </div>

        <mat-paginator #paginator (page)="handlePageEvent($event)" [length]="droneCount" [pageSize]="pageSize"
            [disabled]="false" [showFirstLastButtons]="true" [pageSizeOptions]="[5, 10, 25]" [hidePageSize]="false"
            [pageIndex]="pageIndex" aria-label="Select page">
        </mat-paginator>
        }
        @if (droneCount == 0) {
        <p>No Drones found</p>
        }
    </section>
</section>